// src/utils/Riba_engine.js

/**
 * RİBA İSTATİSTİKSEL HESAPLAMA MOTORU (DİNAMİK KADEME DESTEKLİ)
 * Lise, Ortaokul ve İlkokul formlarının Z-Puanı ve ASP hesaplamalarını otomatik ayırarak yapar.
 */

// 1. LİSE HEDEFLERİ (Mevcut ve Kusursuz Çalışan)
const RIBA_TARGETS_MAP_LISE = {
    'M05': 'Atılganlık', 'M24': 'Verimli Ders Çalışma Teknikleri/Öz Düzenlemeli Öğrenme', 'M08': 'Stresle Baş Etme Becerileri', 'M03': 'Karar Verme Becerisi', 'M36': 'Psikolojik Sağlamlık', 'M01': 'Sınır Koyma', 'M21': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi', 'M30': 'Okula ve Çevreye Uyum/Okul kuralları', 'M09': 'Gelişim Dönemi Özellikleri', 'M06': 'İletişim Becerileri', 'M39': 'Otokontrol', 'M10': 'Gelişim Dönemi Özellikleri', 'M15': 'İhmal ve İstismardan Korunma', 'M28': 'Üst Öğrenim Kurumlarının Tanıtılması', 'M29': 'Üst Öğrenime Geçiş Sınavları', 'M17': 'Bilinçli Teknoloji Kullanımı', 'M14': 'İletişim Becerileri', 'M26': 'Mesleki Hedef Belirleme', 'M40': 'Aile İçi İletişim', 'M19': 'Meslek Tanıtımı', 'M23': 'Meslek Seçerken Dikkat Edilmesi Gereken Hususlar', 'M42': 'Yardım Arama', 'M02': 'Öfke Yönetimi', 'M34': 'Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması', 'M41': 'Duygu Düzenleme', 'M13': 'Bağımlılıkla Mücadele', 'M11': 'Çatışma Çözme Becerileri/Atılganlık', 'M32': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M35': 'Sağlıklı Yaşam', 'M22': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi', 'M20': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi', 'M37': 'Bireysel Farklılıklara Saygı', 'M16': 'Bilinçli Teknoloji Kullanımı', 'M04': 'Özgüven Geliştirme', 'M25': 'Zaman Yönetimi/ Öz Düzenlemeli Öğrenme', 'M31': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M27': 'Sınav Kaygısı', 'M38': 'Akran Zorbalığı', 'M43': 'Motivasyon/Devamsızlığı önleme', 'M44': 'Okulda Seçilecek Alan/Dal'
};

// 2. ORTAOKUL HEDEFLERİ (39 Madde - Yeni Eklendi)
const RIBA_TARGETS_MAP_ORTAOKUL = {
    'M12': 'Problem Çözme Becerileri', 'M30': 'Öz Düzenlemeli Öğrenme', 'M08': 'Karar Verme Becerisi', 'M29': 'Motivasyon/Devamsızlığı Önleme', 'M07': 'Sosyal Beceriler', 'M36': 'Üst Öğrenime Geçiş Sınavları', 'M34': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M15': 'Atılganlık', 'M48': 'Yardım Arama', 'M04': 'Öz Disiplin Geliştirme', 'M42': 'Duygu Düzenleme', 'M11': 'Bilinçli Teknoloji Kullanımı', 'M31': 'Zaman Yönetimi/Öz Düzenlemeli Öğrenme', 'M13': 'Gelişim Dönemi Özellikleri', 'M14': 'Hak ve Sorumluluklarını Bilme', 'M23': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik ', 'M32': 'Üst Öğrenim Kurumlarının Tanıtılması', 'M47': 'Psikolojik Sağlamlık', 'M33': 'Dikkat Geliştirme Çalışmaları', 'M16': 'Bağımlılıkla Mücadele', 'M03': 'İletişim Becerileri', 'M39': 'Mesleki Benlik', 'M19': 'Çatışma Çözme Becerileri', 'M45': 'Bireysel Farklılıklara Saygı', 'M46': 'Aile İçi İletişim', 'M06': 'Öfke Yönetimi', 'M09': 'Sınır Koyma', 'M27': 'Okula ve Çevreye Uyum/Okul Kuralları', 'M10': 'İletişim Becerileri', 'M38': 'Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması', 'M01': 'Özgüven Geliştirme', 'M35': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M22': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik ', 'M37': 'Sınav Kaygısı', 'M41': 'İhmal ve İstismardan Korunma', 'M18': 'Yaşam Becerileri', 'M44': 'Sağlıklı Yaşam', 'M05': 'Akran Zorbalığı', 'M02': 'Duygu Farkındalığı/Duygu Düzenleme'
};

// 3. İLKOKUL HEDEFLERİ (38 Madde - Yeni Eklendi)
const RIBA_TARGETS_MAP_ILKOKUL = {
    'M42': 'Özgüven Geliştirme', 'M28': 'Okula ve Çevreye Uyum/Okul Kuralları', 'M27': 'Hedef Belirleme', 'M21': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi', 'M40': 'Çatışma Çözme Becerileri', 'M02': 'Öz Disiplin Geliştirme', 'M11': 'Karar Verme Becerisi', 'M14': 'Öz Disiplin Geliştirme', 'M07': 'Çatışma Çözme Becerileri', 'M38': 'Aile İçi İletişim', 'M13': 'Problem Çözme Becerileri', 'M35': 'Rehberlik ve Psikolojik Danışma Servisinin Tanıtılması', 'M08': 'Sosyal Beceriler', 'M16': 'İş Birliği Geliştirme', 'M19': 'Meslek Tanıtımı', 'M41': 'Bireysel Farklılıklara Saygı', 'M15': 'Yaşam Becerileri', 'M32': 'Dikkat Geliştirme Çalışmaları', 'M29': 'Öz Düzenlemeli Öğrenme', 'M31': 'Üst Öğrenim Kurumlarının Tanıtılması', 'M26': 'Motivasyon/Devamsızlığı Önleme', 'M04': 'Duygu Farkındalığı/Duygu Düzenleme', 'M34': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M12': 'Bilinçli Teknoloji Kullanımı', 'M05': 'İletişim Becerileri', 'M06': 'Akran Zorbalığı', 'M01': 'Hak ve Sorumluluklarını Bilme', 'M22': 'Meslek ile İlgi, Değer, Yetenek ve Kişisel Özellik İlişkisi', 'M33': 'Okul ve Çevresindeki Sosyokültürel İmkanlar', 'M24': 'Verimli Ders Çalışma Teknikleri', 'M44': 'Sağlıklı Yaşam', 'M36': 'İhmal ve İstismardan Korunma', 'M09': 'Sosyal Beceriler', 'M25': 'Akademik Öz Yeterlik', 'M10': 'Sınır Koyma', 'M18': 'Meslek Sahibi Olmanın Önemi', 'M30': 'Zaman Yönetimi', 'M45': 'Yardım Arama'
};

// VERİDEN KADEMEYİ ANLAYAN VE DOĞRU HARİTAYI ÇEKEN ZEKİ YAPI
const getDynamicMap = (submissions) => {
    if (!submissions || submissions.length === 0) return RIBA_TARGETS_MAP_LISE;
    const sampleId = submissions[0].testId || '';
    if (sampleId.includes('ilkokul')) return RIBA_TARGETS_MAP_ILKOKUL;
    if (sampleId.includes('ortaokul')) return RIBA_TARGETS_MAP_ORTAOKUL;
    return RIBA_TARGETS_MAP_LISE; // Varsayılan Lise
};

const getMean = (values) => values.length === 0 ? 0 : values.reduce((a, b) => a + b, 0) / values.length;

const getStandardDeviation = (values, mean) => {
    if (values.length <= 1) return 1;
    const variance = values.reduce((a, b) => a + Math.pow(b - mean, 2), 0) / (values.length - 1);
    return Math.sqrt(variance) || 1;
};

const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

// MEB mantığı: her grup için ayrı standart puan/T puan üret
const calculateGroupTScores = (submissions, currentMap) => {
    if (!submissions || submissions.length === 0) return null;

    const targetCounts = {};
    Object.keys(currentMap).forEach(code => targetCounts[code] = 0);

    submissions.forEach(sub => {
        if (sub.answers) {
            sub.answers.forEach(ans => {
                if (ans.code && targetCounts[ans.code] !== undefined) {
                    targetCounts[ans.code] += 1;
                }
            });
        }
    });

    const frequencies = Object.values(targetCounts);
    const mean = getMean(frequencies);
    const sd = getStandardDeviation(frequencies, mean);

    const tScores = {};
    Object.keys(targetCounts).forEach(code => {
        const f = targetCounts[code];
        tScores[code] = ((f - mean) / sd) * 10 + 50;
    });

    return tScores;
};

// MEB ağırlıkları: Gerekirse Excel'deki B48-C48-D48 değerlerine göre değiştir
const RIBA_GROUP_WEIGHTS = {
    student: 1 / 3,
    parent: 1 / 3,
    teacher: 1 / 3
};

export const calculateRibaClassASP = (submissions) => {
    if (!submissions || submissions.length === 0) return null;

    const currentMap = getDynamicMap(submissions);

    const studentSubs = submissions.filter(s =>
        s.studentClass !== 'Öğretmen' &&
        !(s.studentNo?.toString().includes('Veli'))
    );

    const parentSubs = submissions.filter(s =>
        s.studentNo?.toString().includes('Veli')
    );

    const teacherSubs = submissions.filter(s =>
        s.studentClass === 'Öğretmen'
    );

    const tStudent = calculateGroupTScores(studentSubs, currentMap);
    const tParent = calculateGroupTScores(parentSubs, currentMap);
    const tTeacher = calculateGroupTScores(teacherSubs, currentMap);

    const results = [];

    Object.keys(currentMap).forEach(code => {
        let asp = 0;
        let usedWeight = 0;

        if (tStudent) {
            asp += tStudent[code] * RIBA_GROUP_WEIGHTS.student;
            usedWeight += RIBA_GROUP_WEIGHTS.student;
        }

        if (tParent) {
            asp += tParent[code] * RIBA_GROUP_WEIGHTS.parent;
            usedWeight += RIBA_GROUP_WEIGHTS.parent;
        }

        if (tTeacher) {
            asp += tTeacher[code] * RIBA_GROUP_WEIGHTS.teacher;
            usedWeight += RIBA_GROUP_WEIGHTS.teacher;
        }

        if (usedWeight === 0) return;

        // Eğer bir grup yoksa kalan ağırlıklara göre normalize eder
        const normalizedAsp = asp / usedWeight;

        results.push({
            code,
            target: currentMap[code],
            asp: normalizedAsp,
            aspRounded: round2(normalizedAsp),
            studentT: tStudent ? round2(tStudent[code]) : null,
            parentT: tParent ? round2(tParent[code]) : null,
            teacherT: tTeacher ? round2(tTeacher[code]) : null
        });
    });

    const sortedResults = results.sort((a, b) => b.asp - a.asp);
    sortedResults.forEach((item, idx) => item.isTopTwo = idx < 2);

    return {
        isRiba: true,
        type: 'class',
        summary: "Sınıf Sonuç Çizelgesi (Ana Hedefler)",
        analysis: "Öğrenci, veli ve öğretmen grupları için ayrı standart puanlar hesaplanmış; ASP puanı MEB mantığına uygun ağırlıklı birleşimle oluşturulmuştur.",
        ribaTable: sortedResults
    };
};

export const calculateRibaSchoolASP = (allSubmissions) => {
    if (!allSubmissions || allSubmissions.length === 0) return null;

    const currentMap = getDynamicMap(allSubmissions);

    // 1. Sınıfları tespit et
    const classNames = [...new Set(
        allSubmissions
            .map(s => s.studentClass)
            .filter(c => c && c !== 'Öğretmen' && c !== 'Veli')
    )];

    const classResults = []; // Sınıf sonuçlarını tutacak dizi

    // 2. Her sınıfın ASP'sini ayrı ayrı hesapla
    classNames.forEach(cls => {
        const subsForClass = allSubmissions.filter(s =>
            s.studentClass === cls ||
            (s.studentNo?.toString().includes('Veli') && s.studentClass === cls)
        );
        const classResult = calculateRibaClassASP(subsForClass);
        if (classResult) classResults.push(classResult.ribaTable);
    });

    const finalSchoolResults = [];

    // 3. MEB'in Excel Formülünü Taklit Et:
    // Sınıf mevcuduna bakmaksızın, her sınıfın ASP değerini topla ve sınıf sayısına böl.
    Object.keys(currentMap).forEach(code => {
        let totalASP = 0;
        let validClassesCount = 0;

        classResults.forEach(classTable => {
            const targetData = classTable.find(t => t.code === code);
            if (targetData) {
                // MEB'in "ortalama" hücresindeki gibi, sadece sınıfın ASP değerini ekle.
                totalASP += targetData.asp; 
                validClassesCount++;
            }
        });

        if (validClassesCount > 0) {
            const schoolAvgASP = totalASP / validClassesCount; // Basit aritmetik ortalama

            finalSchoolResults.push({
                code,
                target: currentMap[code],
                asp: schoolAvgASP,
                aspRounded: round2(schoolAvgASP)
            });
        }
    });

    // Sıralama ve dönüştürme
    const sortedSchoolResults = finalSchoolResults.sort((a, b) => b.asp - a.asp);
    sortedSchoolResults.forEach((item, idx) => item.isTopTwo = idx < 2);

    return {
        isRiba: true,
        type: 'school',
        summary: "Okul Sonuç Çizelgesi (Ana Hedefler)",
        analysis: "MEB Excel şablonu mantığına uygun olarak; her sınıfın ASP'si eşit ağırlıkta toplanıp sınıf sayısına bölünmüştür.",
        ribaTable: sortedSchoolResults,
        totalParticipants: allSubmissions.length
    };
}; 

// Riba_engine.js dosyasının en altına şunu ekle:
export const calculateRibaIndividual = (answers) => {
    if (!answers || !Array.isArray(answers)) return null;
    
    const targetCounts = {};
    const detailedAnswers = [];

    answers.forEach((item, index) => {
        if (!item.target) return;
        if (!targetCounts[item.target]) targetCounts[item.target] = { target: item.target, score: 0 };
        targetCounts[item.target].score += 1;
        detailedAnswers.push({ id: index + 1, choice: item.selectedChoice, target: item.target });
    });

    const sortedTargets = Object.values(targetCounts).sort((a, b) => b.score - a.score);
    sortedTargets.forEach((t, idx) => t.isTopTwo = idx < 2);

    return {
        riskScore: sortedTargets.length > 0 ? sortedTargets[0].score : 0,
        masterRisk: "none",
        isCritical: false,
        domain: "profile",
        isRiba: true, 
        type: 'individual', 
        summary: "Bireysel İhtiyaç Özeti (Ana Hedefler)",
        analysis: "Bu rapor öğrencinin/katılımcının rehberlik ihtiyaçlarını belirlemek amacıyla verdiği yanıtlar üzerinden oluşturulmuştur.",
        ribaTable: sortedTargets,
        userSelections: detailedAnswers
    };
};